import Vue from 'vue';
import antInputDirective from 'ant-design-vue/es/_util/antInputDirective';
import Input from './src';
import './style';

Vue.use(antInputDirective);
Input.install = (Vue) => {
  Vue.component('DInput', Input);
  Vue.component('DInputGroup', Input.Group);
  Vue.component('DInputSearch', Input.Search);
  Vue.component('DTextarea', Input.TextArea);
};

export default Input;
